import LogoColored from "assets/images/logo/logo-colored.svg";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const LoadingFallback = ({ allowLogo, height = "h-100", text = { mainHeader: "", description: "", footnote: "" } }) => {
	const { t } = useTranslation();

	return (
		<div className={`root-loading ${height} d-flex align-items-center justify-content-center p-4`}>
			{allowLogo ? (
				<img
					src={LogoColored}
					alt={`${t("content.loading")}...`}
					title={`${t("content.loading")}...`}
					width="200"
					height="60"
				/>
			) : (
				<div className="flex flex-row align-items-center justify-content-center text-center">
					<span className="spinner-border border-2" role="status">
						<span className="visually-hidden">{`${t("content.loading")}...`}</span>
					</span>
					{text && (
						<div
							className="flex flex-column align-items-center justify-content-center text-center mt-4"
							style={{ maxWidth: 400, width: "100%" }}>
							{text.mainHeader && <h5 className="font-weight-bold">{text.mainHeader}</h5>}
							{text.description && <p className="text-muted">{text.description}</p>}
							{text.footnote && (
								<p className="text-muted" style={{ fontSize: "0.8em" }}>
									<em>{text.footnote}</em>
								</p>
							)}
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default memo(LoadingFallback);
